import { memo } from 'react';
import { useLocalization } from '../../Contexts/Localization';
import { GMDialog, ComponentProps as ModalProps } from './Dialog';

interface ComponentProps extends Omit<ModalProps, 'buttons'> {
    /**
     * Ok button text. Default 'Ok'
     */
    okText?: string;
    /**
     * Callback for when the backdrop/close icon/ok button is clicked
     */
    onClose: () => void;
}

/**
 * Single button dialog. Clicking the button closes the dialog
 */
export const OkDialog: React.FC<ComponentProps> = memo(({ okText, ...modalProps }) => {
    const Localization = useLocalization();

    return (
        <GMDialog
            {...modalProps}
            buttons={[
                { children: okText ? okText : Localization.Ok,
                    onClick: modalProps.onClose,
                    buttonType: 'primary_button' },
            ]}
        />
    );
});